import { api } from './client';

export interface FontDTO {
  name: string;
  url: string;
}

export const fontsApi = {
  // Список загруженных шрифтов. Идёт через api-клиент → с пользовательским JWT
  // (раньше слался анонимный ключ → 401, список шрифтов не грузился).
  async list(): Promise<FontDTO[]> {
    const res = await api.get<{ fonts: FontDTO[] }>('/fonts');
    return res.fonts || [];
  },

  // Сохраняет загруженный шрифт в общий бакет (make-bde4f709-fonts) через бэкенд,
  // чтобы он появился в списке /fonts во всех шаблонах. Возвращает имя + signed URL.
  async upload(file: File): Promise<FontDTO> {
    const form = new FormData();
    form.append('file', file);
    const res = await api.postFormData<{ name: string; url: string }>('/fonts/upload', form);
    return { name: res.name, url: res.url };
  },
};
